import React, { useContext, useState } from 'react'
import {
    Box,
    Stack,
    Toolbar,
    Typography
} from '@mui/material'
import emailjs from '@emailjs/browser'

import Header from '../../utils/header.js'
import { AppContext } from '../../context/context/context.js'
import { ColorButton } from '../../utils/button.js'
import CustomTextField from '../../utils/textfield.js'

import data from '../../data/contact.json'

const Contact = () => {
    const { state } = useContext(AppContext)
    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()

        emailjs.send(data.serviceID, data.templateID, {
            name: name,
            phone: phone,
        }, data.publicKey)
            .then(alert("Email was sent successfully"))
            .catch(err => alert(err.message))
    }

    return (
        <Box textAlign={"center"}>
            <Toolbar />
            <Header color={state.color.light} title="Let's work together" />
            <Stack
                direction={"row"}
                justifyContent="center"
                alignItems={"center"}
                spacing={{ xs: 1, sm: 2, md: 4 }}
            >
                <Box
                    sx={{
                        width: { xs: "85%", md: "50%" },
                        padding: 5,
                    }}>
                    <form onSubmit={handleSubmit}>
                        <CustomTextField
                            type="text"
                            variant='outlined'
                            label="Name"
                            onChange={e => setName(e.target.value)}
                            value={name}
                            fullWidth
                            required
                            sx={{ mb: 6 }}
                        />
                        <CustomTextField
                            type="text"
                            variant='outlined'
                            label="Phone Number"
                            onChange={e => setPhone(e.target.value)}
                            value={phone}
                            fullWidth
                            required
                            sx={{ mb: 8 }}
                        />
                        <ColorButton
                            variant="contained"
                            type="submit"
                            size='large'
                            sx={{ width: { xs: 1 / 2 } }}
                        >Send</ColorButton>
                    </form>
                    <Stack
                        direction={{ xs: "column" }}
                        justifyContent="center"
                        alignItems={"center"}
                        spacing={{ xs: 2 }}
                        mt={10}>
                        <Typography
                            color={state.color.secondary}
                            fontFamily={"League Gothic, sans-serif"}
                            variant='p'
                            fontSize={32}
                            sx={{ textAlign: "center", mt: 5 }}>
                            ــــــــ Or Call Me ــــــــ
                        </Typography>
                        <Stack
                            direction={{ xs: "row" }}
                            justifyContent="space-between"
                            alignItems={"center"}
                            spacing={{ xs: 2 }}>
                            <Typography
                                component={"a"}
                                fontFamily={"League Gothic, sans-serif"}
                                fontSize={28}
                                href="tel:01270014050"
                                sx={{
                                    textDecoration: "none",
                                    color: state.color.secondary
                                }}>
                                +20 127 0014 050
                            </Typography>
                        </Stack>
                    </Stack>
                </Box>
            </Stack>
        </Box>
    )
}

export default Contact